import store from '@/store';
import * as Sentry from "@sentry/vue";

export default async incomingRoute => {

    try {
      
        const redirect = await store.dispatch('routeEnforcer/enforceRoute', incomingRoute);

        return redirect ? redirect : null;

    } catch (error) {
        throw error;
    };

};